import React from "react";

const OptOutPage = React.lazy(() =>
    import(
        "../../../containers/QuestionnaireParent/QuestionnairePages/OptOutPage/OptOutPage"
    )
);
const TherapistEndSession = React.lazy(() =>
    import("../../../containers/TherapistEndSession/TherapistEndSessionContainer")
);
const Greetings = React.lazy(() =>
    import("../../../containers/Greetings/GreetingsContainer")
);
const QuestionnaireParentContainer = React.lazy(() =>
    import("../../../containers/QuestionnaireParent/QuestionnaireParentContainer")
);
const MatchScorePage = React.lazy(() =>
import("../features/match-score/MatchScore")
);
const ZoomContainer = React.lazy(() =>
    import("../../../components/modules/zoomInformation/ZoomInformationContainer")
);
const ClinicianAvailability = React.lazy(() =>
    import(
        "../../../containers/ClinitianAvailability/Matching/ClinicianAvailabilityPage"
    )
);
const ClientDashboard = React.lazy(() =>
    import("../../../containers/ClientDashboard/ClientDashboardContainer")
);
const TherapistDashboard = React.lazy(() =>
    import("../../../containers/TherapistDashboard/TherapistDashboardContainer")
);
const SchedulerDashboard = React.lazy(() =>
  import("../features/scheduler-dashboard/SchedulerDashboard")
);
const TherapistProfileSettings = React.lazy(() =>
    import(
        "../../../containers/TherapistProfileSettings/TherapistProfileSettingsContainer"
    )
);
const Calendar = React.lazy(() =>import("../features/Calendar/CalendarContainer"));

export const therapyRoutes = [
  {
    path: 'client',
    component: ClientDashboard,
    exact: true,
  },
  {
    path: 'initquestions',
    name: QuestionnaireParentContainer,
    component: QuestionnaireParentContainer,
  },
  {
    path: 'match-score',
    name: MatchScorePage,
    component: MatchScorePage,
  },
  {
    path: 'therapist',
    component: TherapistDashboard,
    exact: true,
  },
  {
    path: 'session-ended',
    name: 'TherapistEndSession',
    component: TherapistEndSession,
  },
  {
    path: 'scheduler',
    component: SchedulerDashboard,
    exact: true,
  },
  {
    path: 'settings',
    component: TherapistProfileSettings,
    exact: true,
  },
  {
    path: 'greetings',
    name: 'Greetings',
    component: Greetings,
  },
  {
    path: 'opt-out',
    name: 'Optout',
    component: OptOutPage,
  },
  {
    path: 'zoom',
    name: 'Zoom',
    component: ZoomContainer,
  },
  {
    path: 'clinician-availability',
    name: 'ClinicianAvailability',
    component: ClinicianAvailability,
  },
  {
    path: 'calendar',
    name: 'calendar',
    component: Calendar,
  }
];
